__turbopack_context__.v({
  "spinner": "K8EAOG_spinner",
  "text": "K8EAOG_text",
});
